import React from 'react'

export default function Demo() {
  return (
    <script>Demo</script>
  )
}
